/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface QueryResultsAPI
 * @hideconstructor
 * @classdesc API class that is used to access query results.
 * @example dataQueryExecution.getCurrentQueryResults()
 */
define([], () => {
	class QueryResultsAPI {

		/**
		 * @function QueryResultsAPI#getResult
		 * @description Gets a single {@link QueryResultAPI}.
		 * @public
		 *
		 * @param {String} [id = 'data'] query id
		 * @return {QueryResultAPI} QueryResultAPI object {@link QueryResultAPI}
		 */
		getResult() {}

		/**
		 * @function QueryResultsAPI#getQueryResultIdList
		 * @description Gets the IDs of query results.
		 * @public
		 *
		 * @return {String[]} Array of query result IDs.
		 */
		getQueryResultIdList() {}

		/**
		 * @function QueryResultsAPI#getCacheValidateTag
		 * @description Gets the query tag that uniquely identifies the query result data. It is built from query specs and the last-modified timestamp of the data source.
		 * @private
		 *
		 * @return {Number} Returns the tag.
		 */
		getCacheValidateTag() {}

		/**
		 * Gets the list of warnings generated while executing the query.
		 * @return {QueryWarning[]}
		 * @private
		 */
		getWarningList() {}
	}

	/**
	 * @description  Enum for query result types. Internal second argument of getResult.
	 * @readonly
	 * @enum {String}
	 * @constant
	 * @private
	 * @memberOf QueryResultsAPI
	 */
	QueryResultsAPI.QUERY_RESULT_TYPE = {
		/** The main query type */
		MAIN: 'main',
		/** The minmax query type */
		MINMAX: 'minmax'
	};

	return QueryResultsAPI;
});
